import { render, staticRenderFns } from "./Namjestaj.vue?vue&type=template&id=36295472&scoped=true"
import script from "./Namjestaj.vue?vue&type=script&lang=js"
export * from "./Namjestaj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36295472",
  null
  
)

export default component.exports